import { useNavigate } from "react-router-dom";
import DashboardLayout from "../components/dashboard-layout";
import logoFull from "../assets/Logo_full.png";

const PRINCIPAL = {
  name: "Dr. Sujito, S.Pd., M.Si",
  role: "Principal Investigator",
  institution: "Universitas Negeri Malang",
  email: "sujito.fmipa@um.ac.id",
  initials: "SJ",
};

const TEAM = [
  { name: "Dr. Hari Wisodo, S.Pd., M.Si.", role: "Co-Researcher", initials: "HW", color: "#6366F1" },
  { name: "Nugroho Adi Pramono, S.Si., M.Sc.", role: "Research Coordinator", initials: "NA", color: "#0EA5E9" },
  { name: "Ariko Yahya Setyawan, S.Si.", role: "Research Member", initials: "AY", color: "#10B981" },
  { name: "Anugerah Agung Dwi Putra, S.Si.", role: "Research Member", initials: "AA", color: "#F59E0B" },
];

const FEATURES = [
  { icon: "🤖", color: "#6366F1", bg: "#EEF2FF", title: "AI Spesialis Arduino", desc: "AI terlatih khusus untuk Arduino, ESP32, NodeMCU, dan elektronik." },
  { icon: "💻", color: "#0EA5E9", bg: "#E0F2FE", title: "Kode Siap Pakai", desc: "Kode lengkap dengan penjelasan mendalam dalam satu percakapan." },
  { icon: "📋", color: "#10B981", bg: "#D1FAE5", title: "Template Beragam", desc: "Koleksi template dari level pemula hingga lanjutan." },
  { icon: "🎓", color: "#F59E0B", bg: "#FEF3C7", title: "Berbasis Riset STEAM", desc: "Dikembangkan oleh peneliti berpengalaman dari Universitas Negeri Malang." },
  { icon: "🔗", color: "#EC4899", bg: "#FCE7F3", title: "Multi-Platform", desc: "Mendukung berbagai platform IoT dan embedded systems." },
  { icon: "🚀", color: "#8B5CF6", bg: "#EDE9FE", title: "Inovasi Berkelanjutan", desc: "Terus berkembang untuk ekosistem IoT & STEAM Indonesia." },
];

const STATS = [
  { value: "5", label: "Anggota Tim", icon: "👥", color: "#6366F1", bg: "#EEF2FF" },
  { value: "1", label: "Institusi", icon: "🏛️", color: "#0EA5E9", bg: "#E0F2FE" },
  { value: "17+", label: "Template", icon: "📂", color: "#10B981", bg: "#D1FAE5" },
  { value: "4", label: "Platform", icon: "💡", color: "#F59E0B", bg: "#FEF3C7" },
];

export default function Tentang() {
  const navigate = useNavigate();

  return (
    <DashboardLayout>
      <div className="about-page">

        {/* ── Hero ── */}
        <div className="about-hero">
          <div className="about-hero-circles">
            <div className="about-circle1" />
            <div className="about-circle2" />
          </div>
          <button className="about-back-btn" onClick={() => navigate("/profil")}>← Profil</button>
          <div className="about-hero-badge">
            <span>🛡️</span> Universitas Negeri Malang
          </div>
          <img src={logoFull} alt="AiDuNode" className="about-hero-logo" />
          <h1 className="about-hero-title">AiDuNode</h1>
          <p className="about-hero-sub">Tim Peneliti & Inovator</p>
          <p className="about-hero-desc">
            Menghadirkan AI-integrated learning berbasis Arduino untuk generasi STEAM Indonesia.
          </p>
          <div className="about-hero-chip">💡</div>
        </div>

        {/* ── Stats ── */}
        <div className="about-stats-row">
          {STATS.map((s, i) => (
            <div key={i} className="about-stat-box">
              <div className="about-stat-icon" style={{ background: s.bg }}>
                <span>{s.icon}</span>
              </div>
              <div className="about-stat-val" style={{ color: s.color }}>{s.value}</div>
              <div className="about-stat-lbl">{s.label}</div>
            </div>
          ))}
        </div>

        {/* ── Ketua Peneliti ── */}
        <div className="about-section-label">
          <div className="about-section-pill" style={{ background: "#1565C0" }} />
          <span>Ketua Peneliti</span>
        </div>
        <div className="about-pi-card">
          <div className="about-pi-accent" />
          <div className="about-pi-body">
            <div className="about-pi-avatar-wrap">
              <div className="about-pi-avatar">{PRINCIPAL.initials}</div>
              <div className="about-pi-crown">🏅</div>
            </div>
            <div className="about-pi-meta">
              <div className="about-pi-name">{PRINCIPAL.name}</div>
              <div className="about-pi-role-pill">
                <span>⭐</span> {PRINCIPAL.role}
              </div>
              <div className="about-pi-detail">🏛️ {PRINCIPAL.institution}</div>
              <a className="about-pi-detail about-pi-email" href={`mailto:${PRINCIPAL.email}`}>
                ✉️ {PRINCIPAL.email}
              </a>
            </div>
          </div>
        </div>

        {/* ── Anggota Tim ── */}
        <div className="about-section-label">
          <div className="about-section-pill" style={{ background: "#6366F1" }} />
          <span>Anggota Tim</span>
        </div>
        <div className="about-team-grid">
          {TEAM.map((m, i) => (
            <div key={i} className="about-team-card">
              <div className="about-team-avatar" style={{ background: m.color }}>{m.initials}</div>
              <div className="about-team-name">{m.name}</div>
              <div className="about-team-role" style={{ color: m.color }}>{m.role}</div>
            </div>
          ))}
        </div>

        {/* ── Fitur Unggulan ── */}
        <div className="about-section-label">
          <div className="about-section-pill" style={{ background: "#10B981" }} />
          <span>Fitur Unggulan</span>
        </div>
        <div className="about-features-grid">
          {FEATURES.map((f, i) => (
            <div key={i} className="about-feature-card">
              <div className="about-feature-icon" style={{ background: f.bg }}>
                <span style={{ fontSize: 22 }}>{f.icon}</span>
              </div>
              <div className="about-feature-title" style={{ color: f.color }}>{f.title}</div>
              <div className="about-feature-desc">{f.desc}</div>
            </div>
          ))}
        </div>

        {/* ── Misi ── */}
        <div className="about-mission-card">
          <div className="about-mission-header">
            <span className="about-mission-icon">🎯</span>
            <span className="about-mission-title">Misi Kami</span>
          </div>
          <p className="about-mission-text">
            AiDuNode hadir untuk mempercepat pembelajaran elektronika dan IoT di Indonesia melalui
            teknologi AI yang cerdas dan kontekstual. Kami percaya bahwa setiap pelajar berhak mendapatkan
            pendampingan berkualitas tinggi dalam belajar Arduino dan embedded systems.
          </p>
        </div>

        {/* ── Footer ── */}
        <div className="about-footer">
          <img src={logoFull} alt="AiDuNode" className="about-footer-logo" />
          <div className="about-footer-text">AiDuNode v1.0.0</div>
          <div className="about-footer-copy">© 2024 Universitas Negeri Malang. All rights reserved.</div>
        </div>

      </div>
    </DashboardLayout>
  );
}
